import axios from "axios"
import { useEffect, useState } from "react"
import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import PageLoader from "../../components/global/loader/PageLoader";
import { InternalBanner } from "../../components/internals/InternalBanner"
import './styles.scss';

export const PracticeAreas = () => {
    const [isFetchingPageData, setIsFetchingPageData] = useState(false);
    const [pageContent, setPageContent] = useState(null);

    useEffect(() => {
        fetchPageContent();
    }, []);

    const fetchPageContent = async () => {
        setIsFetchingPageData(true);
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=get_pages_by_page_name&page_name=practice_area`);
            var data0 = data;
            console.log(data0)

            if (data?.yoast_title?.length > 0) {
                document.title = data?.yoast_title;
            } else {
                document.title = data?.page?.post_title ? `${data?.page?.post_title}` : "Practice Areas - Personal Injury Lawyers NYC - Medical Malpractice Lawyer NYC";
            }
            if (document.querySelector('#wp-admin-bar-edit a')) {
                document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Page`;
                document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=${data?.page?.ID}&action=edit`;
            }

            // if (window.location.href?.includes("/es/")) {
            //     const translations = await window.Weglot.translate(
            //         {
            //             'words': [
            //                 {
            //                     "t": 1,
            //                     "w": data?.page?.post_title
            //                 }
            //             ],
            //             'languageTo':'es'
            //         } 
            //     );
            //     if (translations?.length > 0) {                    
            //         document.title = translations[0];
            //         console.log("title", translations)
            //         setPageContent({
            //             ...data,
            //             post_title: translations[0],
            //         });
            //     } else {
            //         document.title = data?.page?.post_title;
            //     }
            // } else {
            //     setPageContent(data);
            // }

            setPageContent(data);
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetchingPageData(false);
        }
    }

    return <Fade delay={1}>
        <main id="main" className="internal-page internal-pa">
            {
                !isFetchingPageData && <>
                    <InternalBanner page={pageContent?.page} />
                    <section id="pa-section" className="home-section">
                        <div className="container">

                            <div className='pa-wrapper'>
                                <div className='pa-repeater'>
                                    {
                                        pageContent?.fields?.pa_repeater?.map((it, index) => <div className='pa-block-item' key={index}>
                                            <span className='block-icon' dangerouslySetInnerHTML={{ __html: it.block_icon }}></span>
                                            <span className='block-name'>{ it?.block_title }</span>
                                            <Link to={it?.block_link}></Link>
                                        </div>)
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* <PracticeAreasSection fields={pageContent?.home_fields} /> */}
                </>
            }

            {
                isFetchingPageData && <PageLoader />
            }
        </main>
    </Fade>
}